import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaUsers, FaClock, FaStar } from 'react-icons/fa';
import '../Tour/Tour.css';
import TourPost from './Tour-post';
import Serve2 from '../Serve2/Serve2';
import Why2 from '../Why2/Why2';

const featuredData = [
  {
    id: 1,
    img: '/t1.avif',
    title: 'Tropical Paradise Escape',
    desc: 'Relax on pristine white sand beaches with crystal clear waters in this island getaway.',
    rating: 4.8,
    reviews: 24,
    days: '5 Days - 4 Nights',
    people: '1–12',
    location: 'Maldives Islands',
    price: '₹42,999',
    originalPrice: '₹49,999',
    offer: '14% Off',
    tags: ['Luxury', 'Beach']
  },
  {
    id: 2,
    img: '/t2.avif',
    title: 'Coastal Adventure Package',
    desc: 'Explore hidden coves and enjoy water sports along beautiful coastal landscapes.',
    rating: 4.5,
    reviews: 18,
    days: '4 Days - 3 Nights',
    people: '2–10',
    location: 'Goa, India',
    price: '₹18,500',
    originalPrice: null,
    offer: null,
    tags: ['Adventure', 'Water Sports']
  },
  {
    id: 3,
    img: '/t3.avif',
    title: 'Family Beach Vacation',
    desc: 'Perfect family-friendly resort with activities for all ages and beautiful ocean views.',
    rating: 4.7,
    reviews: 32,
    days: '6 Days - 5 Nights',
    people: '2–8',
    location: 'Phuket, Thailand',
    price: '₹35,000',
    originalPrice: '₹39,000',
    offer: '10% Off',
    tags: ['Family', 'Resort']
  },
  {
    id: 4,
    img: '/t4.avif',
    title: 'Romantic Beach Getaway',
    desc: 'Exclusive couples retreat with private beach access and luxury accommodations.',
    rating: 4.9,
    reviews: 41,
    days: '3 Days - 2 Nights',
    people: '2',
    location: 'Bali, Indonesia',
    price: '₹28,999',
    originalPrice: '₹32,000',
    offer: '9% Off',
    tags: ['Romantic', 'Luxury']
  },
  {
    id: 5,
    img: '/t5.avif',
    title: 'Beach Yoga Retreat',
    desc: 'Rejuvenate with daily yoga sessions on the beach and healthy organic meals.',
    rating: 4.6,
    reviews: 15,
    days: '5 Days - 4 Nights',
    people: '1–15',
    location: 'Gokarna, India',
    price: '₹22,500',
    originalPrice: null,
    offer: null,
    tags: ['Wellness', 'Yoga']
  },
  {
    id: 6,
    img: '/t6.avif',
    title: 'Island Hopping Tour',
    desc: 'Discover multiple islands with daily boat trips to the best snorkeling spots.',
    rating: 4.4,
    reviews: 27,
    days: '4 Days - 3 Nights',
    people: '4–12',
    location: 'Andaman Islands',
    price: '₹31,000',
    originalPrice: '₹35,000',
    offer: '11% Off',
    tags: ['Island', 'Snorkeling']
  },
  {
    id: 7,
    img: '/t7.avif',
    title: 'Beachside Camping Experience',
    desc: 'Sleep under the stars right on the beach with all necessary amenities provided.',
    rating: 4.3,
    reviews: 19,
    days: '2 Days - 1 Night',
    people: '1–6',
    location: 'Konkan Coast, India',
    price: '₹8,999',
    originalPrice: null,
    offer: null,
    tags: ['Camping', 'Adventure']
  },
  {
    id: 8,
    img: '/t8.avif',
    title: 'Surfing Adventure Camp',
    desc: 'Learn to surf from professional instructors at prime surfing locations.',
    rating: 4.7,
    reviews: 13,
    days: '3 Days - 2 Nights',
    people: '1–8',
    location: 'Kovalam, India',
    price: '₹14,500',
    originalPrice: '₹16,000',
    offer: '9% Off',
    tags: ['Surfing', 'Sports']
  },
  {
    id: 9,
    img: '/t9.avif',
    title: 'Beach Photography Tour',
    desc: 'Capture stunning coastal landscapes with guidance from professional photographers.',
    rating: 4.5,
    reviews: 8,
    days: '2 Days - 1 Night',
    people: '1–5',
    location: 'Puri, India',
    price: '₹12,999',
    originalPrice: null,
    offer: null,
    tags: ['Photography', 'Workshop']
  }
];


const TourCard = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={`tour-card-tt ${isHovered ? 'hovered-tt' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="card-image-container-tt">
        <img src={item.img} alt={item.title} className="card-img-tt" />
        {item.offer && (
          <div className="offer-badge-tt">
            <span>{item.offer}</span>
          </div>
        )}
        <div className="card-tags-tt">
          {item.tags.map((tag, index) => (
            <span key={index} className="tag-tt">{tag}</span>
          ))}
        </div>
      </div>
      
      <div className="card-content-tt">
        <h3 className="card-title-tt">{item.title}</h3>
        <p className="card-desc-tt">{item.desc}</p>
        
        <div className="rating-container-tt">
          <div className="stars-tt">
            {[...Array(5)].map((_, i) => (
              <FaStar 
                key={i} 
                className={i < Math.floor(item.rating) ? 'star-filled-tt' : 'star-empty-tt'} 
              />
            ))}
          </div>
          <span className="rating-text-tt">{item.rating} ({item.reviews} Reviews)</span>
        </div>
        
        <div className="card-details-tt">
          <div className="detail-item-tt">
            <FaClock className="detail-icon-tt" />
            <span>{item.days}</span>
          </div>
          <div className="detail-item-tt">
            <FaUsers className="detail-icon-tt" />
            <span>{item.people}</span>
          </div>
        </div>
        
        <div className="location-tt">
          <FaMapMarkerAlt className="location-icon-tt" />
          <span>{item.location}</span>
        </div>
        
        <div className={`card-footer-tt ${isHovered ? 'hovered-tt' : ''}`}>
          <div className="price-container-tt">
            <span className="current-price-tt">{item.price}</span>
            {item.originalPrice && (
              <span className="original-price-tt">{item.originalPrice}</span>
            )}
          </div>
          <Link to="/contactus">
          <button className="book-btn-tt">
            Book Now
          </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

const FeaturedTours = () => {
  const [visibleCount, setVisibleCount] = useState(6);
  const totalTours = featuredData.length;

  const toggleTours = () => {
    if (visibleCount >= totalTours) {
      setVisibleCount(6); // Reset to initial count
    } else {
      setVisibleCount(prev => Math.min(prev + 3, totalTours)); // Show 3 more or all remaining
    }
  };

  return (
    <>
      <TourPost/>
      <section className="tours-section-tt">
        <div className="section-header-tt">
          <p className="section-subtitle-tt">
            Featured Tours
          </p>
          <h2 className="section-title-tt">
            Discover Our Most Popular Adventures
          </h2>
          <p className="section-description-tt">
            Explore breathtaking destinations with our expertly curated tours
          </p>
        </div>
        
        <div className="tours-grid-tt">
          {featuredData.slice(0, visibleCount).map((item) => (
            <TourCard key={item.id} item={item} />
          ))}
        </div>
        
        <div className="view-all-container-tt">
          <button 
            className="view-all-btn-tt"
            onClick={toggleTours}
          >
            {visibleCount >= totalTours ? 'See Less' : 'See More'}
          </button>
        </div>
      </section>
      <Serve2/>
      <Why2/>
    </>
  );
};

export default FeaturedTours;